import { render, staticRenderFns } from "./CustomerPopin.vue?vue&type=template&id=285d3f2f"
import script from "./CustomerPopin.vue?vue&type=script&lang=js"
export * from "./CustomerPopin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports